import React from 'react';
import { Formik, Field, Form } from 'formik';
import { Input, Select } from '../../../../_metronic/_partials/controls';
import { jenisKelamin, pendidikan } from '../DonaturUIHelpers';

export const DonaturProfileForm = ({ donaturProfile, btnRef, saveDonaturProfile }) => {
    return (
        <>
            <Formik
                enableReinitialize={true}
                initialValues={donaturProfile}
                onSubmit={(values) => {
                    saveDonaturProfile(values);
                }}
            >
                {({ handleSubmit, handleChange, setFieldValue, values }) => (
                    <>
                        <Form className="form form-label-right">
                            <div className="form-group row">
                                <div className="col-lg">
                                    <Field
                                        type='date'
                                        component={Input}
                                        name='tanggal_lahir'
                                        label="Tanggal Lahir"
                                        value={values.tanggal_lahir || ''}
                                        onChange={e => {
                                            setFieldValue('tanggal_lahir', e.target.value);
                                        }}
                                    />

                                </div>
                                <div className="col-lg">
                                    <Select
                                        name="jenis_kelamin"
                                        label="Jenis Kelamin"
                                    >
                                        <option value="">--PILIH--</option>
                                        {
                                            jenisKelamin.map(row =>
                                                <option key={row.value} value={row.value}>{row.name}</option>
                                            )
                                        }
                                    </Select>
                                </div>
                            </div>
                            <div className="form-group row">
                                <div className="col-lg">
                                    <Field
                                        name="pekerjaan"
                                        component={Input}
                                        placeholder="Contoh: Pegawai Swasta"
                                        label="Pekerjaan"
                                    />
                                </div>
                                <div className="col-lg">
                                    <Select
                                        name="pendidikan"
                                        label="Pendidikan Terakhir"
                                    >
                                        <option value="">-PILIH-</option>
                                        {
                                            pendidikan.map(row =>
                                                <option key={row.value} value={row.value}>{row.value}</option>
                                            )
                                        }
                                    </Select>
                                </div>
                            </div>
                            <div className="form-group row">
                                <div className="col-lg">
                                    <Field
                                        name="hobi"
                                        component={Input}
                                        placeholder="Contoh: Melukis, Memasak...."
                                        label="Hobi"
                                    />
                                </div>
                            </div>
                            <div className="form-group row">
                                <div className="col-lg">
                                    <Field
                                        name="description"
                                        component={Input}
                                        placeholder="Donatur ini adalah ..."
                                        label="Contoh: Tentang Donatur"
                                    />
                                </div>
                            </div>

                            <button
                                type="submit"
                                style={{ display: 'none' }}
                                ref={btnRef}
                                onSubmit={() => handleSubmit()}
                            ></button>
                        </Form>

                    </>
                )}

            </Formik>
        </>
    )
}